import { lazy } from "react"
import { Navigate } from "react-router-dom"
import { inspectionEnergyAuditInProgressRoutes } from "@/pages/dashboard/inspection-energy-audit/inprogress/routes.tsx"
import { BASE_ROLES } from "@/shared/constants"
import type { CustomRoute } from "@/shared/types"
import ErrorPage from "@/shared/ui/error-page.tsx"

const Past = lazy(async () => await import("@/pages/dashboard/inspection-energy-audit/past"))

export const inspectionEnergyAuditRoutes: CustomRoute = {
  path: "inspection-energy-audit",
  handle: {
    label: "Энергоаудит",
    i18Key: "energy-audit",
    icon: "Group",
    allowedRoles: [BASE_ROLES.REPUBLIC_INSPECTOR!, BASE_ROLES.REGIONAL_INSPECTOR!]
  },
  children: [
    {
      path: "",
      element: <Navigate to="periodic-mandatory" />
    },
    inspectionEnergyAuditInProgressRoutes,
    {
      handle: { label: "Прошедшие", i18Key: "past" },
      path: "past",
      Component: Past,
      errorElement: <ErrorPage />
    }
  ]
}
